<template>
  <div class="horizontal-bar">
    <div class="chart-wrap">
      <div class="chart-header flex-wrap">
        <div class="main-font-color title">{{ title }}</div>
      </div>
      <div class="chart-body">
        <div
          ref="chart"
          class="chart-content"
          :style="{ height: height + 'px' }"
        />
        <div class="item-list flex-wrap">
          <div
            v-for="item in showKeys"
            :key="item.key"
            class="item-content fn-clear"
          >
            <div
              class="item-icon fn-left"
              :style="{ borderColor: item.color }"
            />
            <div class="item-info">
              <div class="item-title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'HorizontalBar',
  props: {
    queryData: Array,
    title: String,
    showKeys: Array,
    height: String,
    unit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  watch: {
    queryData() {
      this.drawBar()
    }
  },
  mounted() {
    this.drawBar()
  },
  methods: {
    drawBar() {
      const me = this
      const bar = echarts.init(me.$refs.chart)
      const shopNames = me.queryData.map(e => {
        return e.shop_name
      })
      const data = []
      me.showKeys.forEach((e, i) => {
        const values = me.queryData.map(ele => {
          return ele[e.key]
        })
        data.push({
          name: e.name,
          type: 'bar',
          data: values,
          itemStyle: {
            normal: {
              color: function() {
                const colorList = me.showKeys.map(e => {
                  return e.color
                })
                return colorList[i]
              }
            }
          }
        })
      })
      let max = 0
      const maxList = data.map(e => {
        return Math.max(...e.data)
      })
      max = Math.max(...maxList)
      let end = 100
      if (shopNames.length > 6) {
        end = 40
      }
      bar.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let relVal = params[0].name
            for (let i = 0, l = params.length; i < l; i++) {
              relVal +=
                '<br/>' +
                params[i].marker +
                params[i].seriesName +
                ' : ' +
                params[i].value +
                me.unit
            }
            return relVal
          }
        },
        grid: {
          left: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#999999',
              fontSize: 12
            }
          },
          max: max
        },
        yAxis: {
          type: 'category',
          data: shopNames,
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#999999',
              fontSize: 12
            }
          }
        },
        series: data,
        dataZoom: [
          {
            type: 'slider',
            show: true,
            yAxisIndex: [0],
            left: '93%',
            start: 0,
            end: end,
            textStyle: {
              color: '#999'
            }
          }
        ]
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-wrap {
  width: 100%;
  .chart-header {
    background-color: #f0f3fa;
    height: 60px;
    line-height: 60px;
    padding: 0 30px;
    justify-content: space-between;
    .title {
      font-size: 16px;
    }
  }
  .chart-body {
    background-color: #fafafa;
    .chart-content {
      width: 100%;
    }
    .item-list {
      padding: 0 100px 15px;
      box-sizing: border-box;
      justify-content: space-around;
      flex-wrap: wrap;
      position: relative;
      .item-content {
        .item-icon {
          box-sizing: border-box;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          border-width: 3px;
          border-style: solid;
          border-color: #333;
        }
        .item-info {
          overflow: hidden;
          padding-left: 10px;
          font-size: 14px;
          .item-title {
            color: $color_black;
            margin-bottom: 10px;
          }
          .item-total {
            color: $color_normal;
          }
        }
      }
    }
  }
}
</style>
